import type { TFunction } from '~/core/i18n'
import type { LiveProgramInfo, LiveProgramLocalizedInfo } from './index.h'

import {
  formatDateDuration,
  formatTimeRangeUnified,
  timeWithin,
} from '~/shared/helpers/date'

export const formatToLocalizedView =
  ({ now, t }: { now: number; t: TFunction }) =>
  (info: LiveProgramInfo): LiveProgramLocalizedInfo => {
    // format left time label
    const { hours, minutes } = timeWithin(now, info.actualStopMs)
    const formattedDuration = formatDateDuration({
      duration: { hours, minutes },
      short: true,
    })

    const labelLeft = t('time_left', {
      time: formattedDuration,
    })
    // format duration label
    const labelDuration = formatTimeRangeUnified(
      info.actualStartMs,
      info.actualStopMs
    )

    // format empty description
    const emptyDescription = t('no_epg_data')

    return {
      ...info,
      labelLeft,
      labelDuration,
      emptyDescription,
    }
  }
